import { useState, ChangeEvent, useRef } from 'react';
import { checkTrailingSpace } from '../../js/verificationFunctions';

interface ClaimInputProps {
    placeholder: string,
    className: string,
    value: string | number,
    id: string,
    disabled?: boolean
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const ClaimInput = (props: ClaimInputProps) => {
    const [value, setValue] = useState(props.value);
    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <div>
            <input
                type='text'
                placeholder={props.placeholder}
                className={props.className}
                id={props.id}
                //@ts-ignore
                value={value}
                onBlur={checkTrailingSpace(
                    props.onChange
                )}
                onChange={(e) => setValue(e.target.value)}
            />
        </div>
    )
}

export default ClaimInput